import type businessDocumentVM from "../../../BusinessDocuments/BusinessDocumentSelector/businessDocumentVM";
import {
  type ContractWithdrawalItemViewModel,
  contractWithdrawalItemViewModelToServerModel,
} from "./ContractWithdrawalItemViewModel";
import type { ContractWithdrawalRequestServerVM } from "./ContractWithdrawalRequestServerVM";

export interface ViewModel {
  isConsumerOrPrivilegedEntrepreneurConfirmed: boolean;
  invoice: businessDocumentVM | null;
  items: ContractWithdrawalItemViewModel[];
  comments: string | null;
}

export function viewModelToServerModel(
  vm: ViewModel,
): ContractWithdrawalRequestServerVM {
  return {
    isConsumerOrPrivilegedEntrepreneurConfirmed:
      vm.isConsumerOrPrivilegedEntrepreneurConfirmed,
    // biome-ignore lint/style/noNonNullAssertion: a documentNumber is required before the form can be saved
    invoiceNumber: vm.invoice?.documentNumber!,
    contractWithdrawalItemVMs: vm.items.map((item) =>
      contractWithdrawalItemViewModelToServerModel(item),
    ),
    comments: vm.comments,
  };
}
